import { ACCOUNT_TITLE_ICON } from "../../../constants/icons";
import { ACCOUNT_TITLE } from "../../../constants/urls";

export const Sidebar = {
  addButton: { title: "ایجاد سرفصل‌حساب" },
  menu: [
    {
      title: "لیست سرفصل‌های حساب",
      icon: ACCOUNT_TITLE_ICON,
      link: ACCOUNT_TITLE
    }
  ]
};
